export default "__VITE_ASSET__uUShjFt7__"